import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'

Vue.use(VueI18n)

export const SUPPORTED_LOCALES = ['ko', 'en']
const DEFAULT_LOCALE = 'ko'
const LANG_STORAGE_KEY = 'lang'
const LANG_SELECTED_KEY = 'lang:selected'

// src/locales/<locale>/*.json 파일을 파일명 네임스페이스로 병합한다.
// 예: locales/ko/header.json 의 title -> $t('header.title')
function loadMessages () {
  const messages = {}
  const contexts = {
    ko: require.context('../locales/ko', false, /\.json$/),
    en: require.context('../locales/en', false, /\.json$/)
  }
  SUPPORTED_LOCALES.forEach(locale => {
    messages[locale] = {}
    contexts[locale].keys().forEach(fileName => {
      const namespace = fileName.replace('./', '').replace('.json', '')
      messages[locale][namespace] = contexts[locale](fileName)
    })
  })
  return messages
}

function getDefaultLocale () {
  const saved = localStorage.getItem(LANG_STORAGE_KEY)
  const userSelected = localStorage.getItem(LANG_SELECTED_KEY) === 'true'
  if (userSelected && SUPPORTED_LOCALES.includes(saved)) return saved
  return DEFAULT_LOCALE
}

export const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'ko',
  messages: loadMessages()
})

export function setLocale (locale, persist = true) {
  if (!SUPPORTED_LOCALES.includes(locale)) return
  i18n.locale = locale
  if (persist) {
    localStorage.setItem(LANG_STORAGE_KEY, locale)
    localStorage.setItem(LANG_SELECTED_KEY, 'true')
  }
  moment.locale(locale)
  document.documentElement.lang = locale
}



// WEBPACK FOOTER //
// ./src/i18n/index.js